import React, { useEffect, useState } from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'
import { getStoreWalletPayExpenditure, getTotalExpendetureReport } from '../../Services/Operations/ProductAPI'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const ExpenditureReport = () => {
  const navigate = useNavigate();
   const token = useSelector((state) => state.user.token);
   const[totalStoreCredit,setTotalStoreCredit]=useState(0)
   const[totalPurchaseExpenditure,setTotalPurchaseExpenditure]=useState(0)
   const[totalExpenditure,setTotalExpenditure]=useState(0)
   const[storeWalletCredits,setStoreWalletCredits]=useState([])
   const[purchasePayments,setPurchasePayments]=useState([])


  const handleGetTotalExtendeture=async()=>{
    try {
      const response=await getTotalExpendetureReport(token)
      console.log('getTotalExpendetureReport',response);
      if(response.status===200){
        setTotalExpenditure(response.data.totalExpenditure)
        setTotalPurchaseExpenditure(response.data.totalPurchaseExpenditure)
        setTotalStoreCredit(response.data.totalStoreCredit)
        setPurchasePayments(response.data.purchasePayments)
        setStoreWalletCredits(response.data.storeWalletCredits)
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

   const handleGetStoreWalletPayExpenditure=async()=>{
    try {
      const response=await getStoreWalletPayExpenditure(token)
      console.log('getStoreWalletPayExpenditure',response);
      
    } catch (error) {
      console.log(error);
      
    }
  }

  useEffect(() => {
    handleGetTotalExtendeture()
    handleGetStoreWalletPayExpenditure()
  }, [])
  


  return (
         <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="profit-loss-container">
          <h2 style={{fontSize:"20px"}}>Expenditure Report</h2>
          {/* <div className="date-picker">
            <label>Select Date</label>
            <select
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
            >
              <option>March 6, 2025 - April 4, 2025</option>
              <option>Feb 1, 2025 - March 1, 2025</option>
            </select>
          </div> */}

          <div className="profit-summary" style={{display:"flex",justifyContent:"space-around"}}>
            <div className="summary-card" style={{borderRadius:"10px",backgroundColor:"#422efa",color:"white",padding:"20px",width:"280px"}}>
              <button className="export-btn" style={{borderRadius:"10px",backgroundColor:"#616161",color:"white",padding:"6px"}}>Export</button>
              <h3>Total Expenditure</h3>
              <p>₹ {totalExpenditure}</p>
            </div>
            <div className="summary-card" style={{borderRadius:"10px",backgroundColor:"#422efa",color:"white",padding:"20px",width:"280px"}}>
              <button className="export-btn" style={{borderRadius:"10px",backgroundColor:"#616161",color:"white",padding:"6px"}}>Export</button>
              <h3>Total Purchase Expenditure</h3>
              <p className= "negative" >
                ₹ {totalPurchaseExpenditure}
              </p>
            </div>
            <div className="summary-card" style={{borderRadius:"10px",backgroundColor:"#422efa",color:"white",padding:"20px",width:"280px"}}>
              <button className="export-btn" style={{borderRadius:"10px",backgroundColor:"#616161",color:"white",padding:"6px"}}>Export</button>
              <h3>Total Store Credit</h3>
              <p className= "negative" >
                ₹ {totalStoreCredit}
              </p>
            </div>
          </div>

          <div className="report-sections"
          style={{display:"flex",width:"100%",gap:"10px",margin:"15px",paddingTop:"20px",borderTop:"1px solid black"}}>
                <div className="report-box" style={{width:"40%"}}>  
                   <p style={{textAlign:"center",fontWeight:"600"}}>Store Wallet Payments</p>
                      <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        textAlign: "left"
      }}
    >
      
      <thead>
        <tr>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>ID</th>
      
         
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Payable Amount</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Description</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Transaction Type</th>
          
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Created At</th>
        </tr>
      </thead>
      <tbody>
        {storeWalletCredits.map((payment,ind) => (
          <tr key={payment.id} style={{fontSize:"15px"}}>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>{ind+1}</td>
         
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{payment.amount}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px",fontSize:"12px" }}>{payment.description}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>{payment.transactionType}</td>
           
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {new Date(payment.createdAt).toLocaleString()}
            </td>
          </tr>
        ))}
      </tbody>
    </table></div> 

             <div className="report-box" style={{width:"40%"}}>  
                   <p style={{textAlign:"center",fontWeight:"600"}}>Purchase Payments Transactions</p>
               <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        textAlign: "left"
      }}
    >
      <thead>
        <tr>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>ID</th>
      
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Expenditure</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Payable Amount</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Due Amount</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Payment Mode</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Status</th>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Created At</th>
        </tr>
      </thead>
      <tbody>
        {purchasePayments.map((payment,ind) => (
          <tr key={payment.id} style={{fontSize:"15px"}}>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>{ind+1}</td>
         
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{payment.expenditure}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{payment.payableAmount}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{payment.dueAmount}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>{payment.paymentMode || "N/A"}</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {payment.status === 1 ? "Paid" : "Pending"}
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px",fontSize:"10px" }}>
              {new Date(payment.createdAt).toLocaleString()}
            </td>
          </tr>
        ))}
      </tbody>
    </table></div> 
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExpenditureReport
